export enum Language {
    FI = 'fi',
    SV = 'sv',
    EN = 'en'
}